<template lang="pug">
    .property-value(v-if="!value")
        label {{ label }}
        span.gray {{ $t('Undefined') }}
    .property-value(v-else-if="type === 'unit'")
        label {{ label }}
        span.value {{ value }}
            span.unit {{ unit }}
    //- .property-value(v-else-if="type === 'color'")
    //-     label {{ label }}
    //-     span.value {{ colorName }}
    .property-value(v-else-if="type === 'date'")
        label {{ label }}
        span.value {{ dateValue }}
    .property-value(v-else)
        label {{ label }}
        span.value(v-html="value")
</template>

<i18n>
{
    "de": {
        "Undefined": "Nicht definiert"
    }
}
</i18n>

<script>

import _ from 'lodash'
import { timestamp2date } from '@/filters';

import PropertyPivotValues from '@/extensions/shop/components/Products/PropertyPivotValues';

export default {
    name: 'PropertyValue',
    extends: PropertyPivotValues,
    props: {
        property: {
            type: Object,
            required: true,
        },
        valueOptions: {
            type: undefined,
            required: false,
        }
    },
    computed: {
        value() {
            return _.get(this.property, `valueOption.${this.field}`)
                || _.get(this.property, `value.${this.field}`)
        },
        valueAlt() {
            return _.get(this.property, `valueOption.${this.fieldAlt}`)
                || _.get(this.property, `value.${this.fieldAlt}`)
        },
        dateValue() {
            const value = _.get(this.property, `valueOption.${this.field}`)
                || _.get(this.property, `value.${this.field}`)

            const date = value !== null ? timestamp2date(value, this.dateformat) : null
            return date
        },
    }
}
</script>

<style lang="sass" scoped>
.property-value
    label
        font-style: italic
        &:after
            content: ': '
    span.unit:before
        content: ' '
    .gray
        color: lighten($color-grey-text, 10%)
        font-style: italic
</style>
